<script setup>
import { onUnmounted, watch } from "vue";
import { useMediaQuery } from "@vueuse/core";
import IntroCard from "@components/trivia/IntroCard.vue";
import PhotoCard from "@components/trivia/PhotoCard.vue";
import PhotoCardCenter from "@components/trivia/PhotoCardCenter.vue";
import Countdown from "@components/trivia/Countdown.vue";
import Guesses from "@components/trivia/Guesses.vue";
import InputBar from "@components/trivia/InputBar.vue";
import Sidebar from "@components/trivia/Sidebar.vue";
import Results from "@components/trivia/Results.vue";
import FeedbackFlash from "@components/trivia/FeedbackFlash.vue";
import { useTriviaStore } from "@stores/trivia";
import { useGlobalStore } from "@stores/global";

const triviaStore = useTriviaStore();
const globalStore = useGlobalStore();
const isDesktop = useMediaQuery("(min-width: 1025px)");

watch(
    isDesktop,
    (desktop) => {
        if (desktop) {
            globalStore.showPanel("trivia");
        } else {
            globalStore.hidePanel("trivia");
        }
    },
    { immediate: true },
);

onUnmounted(() => {
    globalStore.hidePanel("trivia");
    triviaStore.reset();
});
</script>

<template>
    <div class="contents">
        <IntroCard />
        <Countdown />
        <PhotoCard />
        <PhotoCardCenter />
        <Guesses />
        <Sidebar />
        <InputBar />
        <Results />
        <FeedbackFlash />
    </div>
</template>
